import React from "react";
import styled from "styled-components";

import ImgWash1 from "../../assets/img/home/wash1.png";
import ImgWash2 from "../../assets/img/home/wash2.png";
import ImgWash3 from "../../assets/img/home/wash3.jpg";
import ImgWash4 from "../../assets/img/home/wash4.jpg";
import ImgWash5 from "../../assets/img/home/wash5.jpg";
import ImgWash6 from "../../assets/img/home/wash6.png";
import ImgWash7 from "../../assets/img/home/wash7.jpg";

export default function Services() {
  return (
      <Wrapper id="services">
        <div className="whiteBg">
          <div className="lightBg">
            <div className="container">
              {/* Teppich-Handwäsche */}
              <Section>
                <h2 className="font30 extraBold">Teppich-Handwäsche</h2>
                <p className="font18">
                  Jeder Teppich durchläuft bei uns einen sorgfältig abgestimmten Reinigungsprozess. Vom Absaugen des tiefsitzenden Staubs
                  über die gezielte Vorbehandlung mit Schmutzlösern bis hin zur intensiven Schaumbürstenwäsche – wir achten auf jedes Detail.
                  Die schonende Trocknung mit Warmluft und die abschließende Begutachtung durch unsere Fachkräfte gewährleisten,
                  dass Ihr Teppich nicht nur sauber, sondern auch in seiner Struktur und Farbbrillanz optimal erhalten bleibt.
                </p>
                <GalleryGrid>
                  <Figure>
                    <img src={ImgWash1} alt="Staub entfernen" />
                    <figcaption>Zuerst wird der Staub mit Hilfe des Klopfsaugers entfernt.</figcaption>
                  </Figure>
                  <Figure>
                    <img src={ImgWash2} alt="Fleckenbehandlung" />
                    <figcaption>Danach erfolgt die intensive Behandlung der Flecken.</figcaption>
                  </Figure>
                </GalleryGrid>

                <GalleryGrid>
                  <Figure>
                    <img src={ImgWash3} alt="Schmutzlöser" />
                    <figcaption>Mit einem speziellen Schmutzlöser wird der Teppich vorbehandelt.</figcaption>
                  </Figure>
                  <Figure>
                    <img src={ImgWash4} alt="Bürstenmaschine" />
                    <figcaption>Der Schmutz wird maschinell mit Schaum entfernt.</figcaption>
                  </Figure>
                </GalleryGrid>

                <GalleryGrid>
                  <Figure2>
                    <img src={ImgWash5} alt="Abtrocknung" />
                    <figcaption>Sanfte Schaumbürste sorgt für gründliche Reinigung.</figcaption>
                  </Figure2>
                </GalleryGrid>

                <GalleryGrid>
                  <Figure>
                    <img src={ImgWash6} alt="Trocknung" />
                    <figcaption>Mit Warmluft werden die Teppiche schonend getrocknet.</figcaption>
                  </Figure>
                  <Figure>
                    <img src={ImgWash7} alt="Begutachtung" />
                    <figcaption>Unsere Fachkräfte prüfen jeden Teppich vor dem Verpacken.</figcaption>
                  </Figure>
                </GalleryGrid>

              </Section>
            </div>
          </div>
        </div>
      </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  //padding-bottom: 0px;
  padding-top: 58px;
`;

const Section = styled.div`
  text-align: center;
`;

const GalleryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Figure = styled.figure`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 380px;
  margin: 5px 20px 20px 5px;

  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    object-fit: cover;
    padding: 5px 0 5px 0
  }

  figcaption {
    @media (max-width: 960px) {
      text-align: center;
    }
  }
`;

const Figure2 = styled.figure`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    object-fit: cover;

    line-height: 1.5rem;
    @media (max-width: 960px) {
      padding: 15px 0 0 0;
      text-align: center;
      max-width: 100%;
    }
  }

  figcaption {
    padding: 5px 0 5px 0;
    line-height: 1.5rem;
    @media (max-width: 960px) {
      padding: 5px 0 15px 0;
      text-align: center;
      max-width: 100%;
    }
  }
`;
